import { ConfigService } from './config.service';
import { inject, provideAppInitializer } from '@angular/core';

const initializeConfig = (): void => {
  const configService = inject(ConfigService);
  configService.initialize({
    apiUrl: APP_CONFIG.API_URL,
    production: APP_CONFIG.PRODUCTION,
    features: {
      analytics: APP_CONFIG.ENABLE_ANALYTICS,
      debugMode: APP_CONFIG.ENABLE_DEBUG_MODE
    }
  });
};

export function provideAppConfig() {
  return [
    provideAppInitializer(initializeConfig)
  ];
}
